module.exports = __webpack_public_path__ + "static/img/fine_wrinkles-01.e514471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/fine_wrinkles-01.jpg
// module id = 270
// module chunks = 1